/**
 * 全局类型声明，为Window对象添加deviceId属性
 */
declare global {
  interface Window {
    deviceId?: string
  }
}

/**
 * 根据支付方式名称获取对应的颜色和图标
 * @param name 支付方式名称（wx：微信支付，alipay：支付宝，upacp：银联，pos_bankcard：POS机）
 * @returns 包含颜色和图标的对象
 */
export function getPayTypeColorWithIcon(name: string): {
  color: string
  icon: string // Iconfont 的 Symbol name
} {
  if (name === 'wx')
    return { color: '#4ECB74', icon: 'icon-zhifuqudao-weixin' }
  if (name === 'alipay')
    return { color: '#3BA1FF', icon: 'icon-zhifuqudao-zhifubao' }
  if (name === 'upacp')
    return { color: '#F2647B', icon: 'icon-yinlian1' }
  if (name === 'pos_bankcard')
    return { color: '#FACC14', icon: 'icon-zhifuqudao-POS' }
  return {
    color: '#36CBCB',
    icon: 'icon-zhifuqudao-gengduo1',
  }
}
